import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Typography, Divider } from 'antd';
import moment from 'moment';
import dynamicData from 'dynamicData';
import DatePickerSimple from 'react-datepicker';
import TemplateFields from 'components/TemplateFields';
import DropDown from 'components/Dropdown';
import SpinBox from 'components/SpinBox';
import { updateReportInfo } from 'redux/report';
import * as API from 'utils/api';
import ClaimantInfo from 'components/ClaimantInfoOnWizard';
import RichTextEditor from '../../../../components/RichTextEditor/RichTextEditor';
import { verifyPermissions, forbiddenRedirect } from '../../utils/verify-permissions';
import { notifyApiError, notifyInfo } from '../../../../utils/notification';
import PrevNextStep from '../../../../components/PrevNextStep';
import { createViewReportIfNotExists } from 'utils/report';
import isAllowed, { ROLES_DIVISIONS } from 'layout/roles';
import { SignatureReport } from 'containers/Reports/components/SignatureReport';
import { INIT_SIGNATURE } from 'containers/Reports/utils/const';
import { getListSignature, matchIdToElement, matchSourceToItem } from 'containers/Reports/utils/helpers';
import InlineContact from 'components/InlineContact';
import { PLAINTIFF_ATTORNEY_TYPE } from 'constants/contact-types';
import { REPORT_LEGAL_DEMAND_NAME } from 'constants/reports';
import { qaHaveAssignedReport } from '../../utils/verify-permissions';
import { CLAIMANT_EDIT, MAIN_NAV } from 'layout/navigate_const';
import { getPermissionsBySection, REPORT_PERMISSIONS_NAME } from 'permissions';

import './MedicalContent.scss';

const { Title, Text } = Typography;

class MedicalContent extends Component {
  constructor(props) {
    super(props);

    let report_id = '';
    if (this.props.match.params && this.props.match.params.id) {
      report_id = this.props.match.params.id;
    }

    // Permissions
    const { REPORT_PERMISSIONS } = getPermissionsBySection({
      roles: this.props.roles,
      permissions: [REPORT_PERMISSIONS_NAME],
    });
    // end permissions

    this.state = {
      report_id: report_id,
      date_of_injury: moment(),
      introduction: '',
      medical_records_reviewed: '',
      description_of_injury: '',
      medical_summary: '',
      missing_medical_records: '',
      related_diagnosis: '',
      pre_existing_conditions: '',
      surgeries_procedures: '',
      treating_providers: undefined,
      current_treatment_plan: '',
      life_expectancy: '',
      projected_treatment_plan: '',
      social_security_disability_status: '',
      medicare_status: '',
      medicare_lien_status: '',
      medicare_allocation_administration: '',
      contactsList: [],
      lifeSources: [],
      lifeTables: [],
      loading: false,
      medical_status: '',
      rated_ages_text: '',
      report_contacts: [],
      prognosis: '',
      references: '',
      treatingList: [],
      report_claim_id: '',
      referral_date: moment(),
      date_of_report: moment(),
      signature: [],
      plaintifList: [],
      REPORT_PERMISSIONS,
    };

    this.getContactLists = this.getContactLists.bind(this);
    this.getReportContacts = this.getReportContacts.bind(this);
    this.handleUpdateReport = this.handleUpdateReport.bind(this);
    this.goToEditClaimant = this.goToEditClaimant.bind(this);
    this.handleChangeSignature = this.handleChangeSignature.bind(this);
    this.handleDeleteSignature = this.handleDeleteSignature.bind(this);
    this.handleAddSignature = this.handleAddSignature.bind(this);
    this.handleUpdateTextArea = this.handleUpdateTextArea.bind(this);
    this.getLifeExpectancy = this.getLifeExpectancy.bind(this);
  }

  async componentDidMount() {
    const { report_id } = this.state;

    this.setState({ loading: true });

    this.getContactLists();

    API.getReportContacts(report_id).then(res => {
      this.setState({ report_contacts: res.report_contacts.rows });
    });

    // si eres Internal QA buscamos la copia del reporte si no existe la creamos
    if (isAllowed(this.props.roles, ROLES_DIVISIONS.QA_ONLY)) {
      await createViewReportIfNotExists({ reportId: report_id });
    }

    API.getReportById(report_id)
      .then(async reportInfo => {
        if (!reportInfo.is_template) {
          verifyPermissions(reportInfo, this.props);
        }

        const redirect = await qaHaveAssignedReport({
          roles: this.props.roles,
          reportId: report_id,
          claimantId: reportInfo.claimant_id,
        });

        if (redirect) return this.props.history.push(MAIN_NAV.path);

        this.props.updateReportInfo(reportInfo);

        API.getLifeSources().then(res => {
          let id = matchSourceToItem(reportInfo.life_expectancy_source, res.life_expects);
          if (!id) {
            this.setState({
              lifeSources: res.life_expects,
              source_id: res.life_expects[0].id,
            });
          } else {
            this.setState({
              lifeSources: res.life_expects,
              source_id: id,
            });
          }
        });
        API.getLifeTables().then(res => {
          let id = matchSourceToItem(reportInfo.life_expectancy_source, res.life_expects);
          if (!id) {
            this.setState({
              lifeTables: res.life_expects,
              life_table_id: res.life_expects[0].id,
            });
          } else {
            this.setState({
              lifeTables: res.life_expects,
              life_table_id: id,
            });
          }
        });
        this.getLifeExpectancy();
        let report_claim_id = reportInfo.report_claim_id
          ? reportInfo.report_claim_id.split('$')[0]
          : Math.floor(Date.now() / 1000) + '';

        this.setState({
          is_template: reportInfo.is_template,
          report_template_id: reportInfo.report_template_id,
          introduction: reportInfo.introduction,
          medical_records_reviewed: reportInfo.medical_records_reviewed,
          description_of_injury: reportInfo.description_of_injury,
          medical_summary: reportInfo.medical_summary,
          missing_medical_records: reportInfo.missing_medical_records,
          related_diagnosis: reportInfo.related_diagnosis,
          pre_existing_conditions: reportInfo.pre_existing_conditions,
          surgeries_procedures: reportInfo.surgeries_procedures,
          treating_providers: reportInfo.treating_providers || undefined,
          current_treatment_plan: reportInfo.current_treatment_plan,
          projected_treatment_plan: reportInfo.projected_treatment_plan,
          social_security_disability_status: reportInfo.social_security_disability_status,
          medicare_status: reportInfo.medicare_status,
          medicare_lien_status: reportInfo.medicare_lien_status,
          medicare_allocation_administration: reportInfo.medicare_allocation_administration,
          life_expectancy: reportInfo.life_expectancy,
          rated_ages_text: reportInfo.rated_ages_text,
          medical_status: reportInfo.medical_status,
          prognosis: reportInfo.prognosis,
          report_claim_id: report_claim_id,
          claimant_id: reportInfo.claimant_id,
          loading: false,
          references: reportInfo.references,
          referral_date: reportInfo.referral_date ? moment(reportInfo.referral_date) : moment(),
          date_of_report: reportInfo.date_of_report ? moment(reportInfo.date_of_report) : moment(),
          signature: getListSignature({ signature: reportInfo.signature }),
        });
      })
      .catch(err => forbiddenRedirect(err, this.props));
  }

  getContactLists() {
    API.getContactsData({ pageSize: 1000 }) //Getting all contacts data
      .then(res => {
        const dynamic = dynamicData();
        this.setState({
          contactsList: res.contacts,
          treatingList: res.contacts.filter(
            item => (item.contact_type ? item.contact_type.name : '') === dynamic.treating_providers
          ),
          plaintifList: res.contacts.filter(
            item => (item.contact_type ? item.contact_type.name : '') === dynamic.plaintiff_attorney
          ),
        });
      });
  }

  async getReportContacts() {
    const { report_id } = this.state;
    let res = await API.getReportContacts(report_id);
    this.setState({ report_contacts: res.report_contacts.rows });
  }

  componentDidUpdate() {
    let { reportInfo } = this.props;
    reportInfo = { ...reportInfo };
    const { lifeSources, lifeTables, life_expectancy } = this.state;

    if (reportInfo.claimant_id && lifeSources.length > 0 && lifeTables.length > 0 && !life_expectancy) {
      const param = {
        source_id: lifeSources[0].id,
        life_table_id: lifeTables[0].id,
      };
      API.getLifeExpect(reportInfo.claimant_id, param)
        .then(res => {
          this.setState({
            life_expectancy: Math.round(res.years_left),
          });
        })
        .catch(() =>
          this.setState({
            life_expectancy: '',
          })
        );
    }
  }

  async handleUpdateReport(isNextStep = false) {
    const {
      report_id,
      introduction,
      medical_records_reviewed,
      description_of_injury,
      medical_summary,
      missing_medical_records,
      related_diagnosis,
      pre_existing_conditions,
      surgeries_procedures,
      treating_providers,
      current_treatment_plan,
      life_expectancy,
      projected_treatment_plan,
      social_security_disability_status,
      medicare_status,
      medicare_lien_status,
      medicare_allocation_administration,
      rated_ages_text,
      medical_status,
      prognosis,
      references,
      date_of_injury,
      report_claim_id,
      referral_date,
      date_of_report,
      signature,
    } = this.state;

    let yrly_src = matchIdToElement(this.state.lifeSources, this.state.source_id);
    let lyfe_table = matchIdToElement(this.state.lifeTables, this.state.life_table_id);

    let life_expectancy_source = yrly_src.name + '.' + lyfe_table.name + ' ';
    const params = {
      life_expectancy_source,
      prognosis,
      references,
      id: report_id,
      report_claim_id,
      introduction,
      medical_records_reviewed,
      description_of_injury,
      medical_summary,
      missing_medical_records,
      related_diagnosis,
      pre_existing_conditions,
      surgeries_procedures,
      treating_providers,
      current_treatment_plan,
      life_expectancy,
      projected_treatment_plan,
      social_security_disability_status,
      medicare_status,
      medicare_lien_status,
      medicare_allocation_administration,
      rated_ages_text,
      medical_status,
      date_of_injury,
      referral_date: moment(referral_date).format('MM/DD/YYYY'),
      date_of_report: moment(date_of_report).format('MM/DD/YYYY'),
      signature: signature.map(item => {
        delete item.imageUrl;
        return { ...item, referral_date: moment(item.referral_date).format('MM/DD/YYYY') };
      }),
    };

    let res;
    try {
      if (isNextStep) {
        this.setState({
          loading: true,
          loadingTitle: 'Saving...  ',
        });
        if (this.state.REPORT_PERMISSIONS.edit) res = await API.updateReport(params);
        clearTimeout(this.timeoutId);
      } else {
        if (this.state.REPORT_PERMISSIONS.edit) res = await API.updateReport(params);
      }
      
      if (res?.status === 201) {
        notifyInfo('', res.message);
      }

      if (res?.report) this.props.updateReportInfo(res.report);
    } catch (e) {
      notifyApiError(e);
    } finally {
      this.setState({ loading: false });
    }
  }

  handleUpdateTextArea(type, value) {
    this.setState({
      [type]: value,
    });
  }

  getLifeExpectancy() {
    if (!this.state.lifeSources[0] || !this.state.life_table_id) {
      setTimeout(() => {
        this.getLifeExpectancy();
      }, 2000);
      return;
    }
    const param = {
      source_id: this.state.lifeSources[0].id,
      life_table_id: this.state.life_table_id,
    };

    API.getLifeExpect(this.state.claimant_id, param)
      .then(res => {
        this.setState({
          life_expectancy: Math.round(res.years_left),
        });
      })
      .catch(() =>
        this.setState({
          life_expectancy: '',
        })
      );
  }

  goToEditClaimant() {
    const claimant = this.props.reportInfo.claimant;
    this.props.history.push(CLAIMANT_EDIT.path, { data: claimant });
  }

  handleChangeSignature(data) {
    this.setState(data);
  }

  handleDeleteSignature({ index }) {
    this.setState({ signature: this.state.signature.filter((item, inde) => inde !== index) });
  }

  handleAddSignature() {
    const add = [...this.state.signature, INIT_SIGNATURE];
    this.setState({ signature: add });
  }

  render() {
    let dataDynamic = { ...dynamicData() };

    const {
      is_template,
      medical_summary,
      projected_treatment_plan,
      report_claim_id,
      loading,
      loadingTitle,
      medical_status,
      referral_date,
      date_of_report,
      signature,
      report_id,
      plaintifList,
      report_contacts,
      REPORT_PERMISSIONS,
    } = this.state;

    return (
      <Row className="msa-medical-content-container">
        <Row type="flex" align="middle" className="header">
          <Col className="title">
            <Title level={4} className="title-text">
              {REPORT_LEGAL_DEMAND_NAME} {this.state.is_template ? 'Template' : 'Report'}
            </Title>
          </Col>
          <Col className="step">
            <DropDown loading={loading} />
          </Col>
        </Row>
        <Row className="main">
          <SpinBox loading={loading} title={loadingTitle}>
            <Row className="content">
              <Row type="flex" justify="space-between" align="middle">
                <Col md={24}>
                  <ClaimantInfo
                    goToEditClaimant={REPORT_PERMISSIONS.edit && this.goToEditClaimant}
                    surgical={true}
                    claimant={{
                      ...this.props.reportInfo.claimant,
                      report_claim_id,
                    }}
                  />
                </Col>
              </Row>
              <Row type="flex" justify="space-between" align="middle" className="row">
                <Col md={24}>
                  <Text className="title">Medical Content</Text>
                </Col>
              </Row>
              <Row>
                <Col md={11}>
                  <Row className="label">
                    <Text>Date of Accident/Injury</Text>
                  </Row>
                  <Row>
                    <DatePickerSimple
                      className="date"
                      placeholderText="Select Date of Accident/Injury"
                      selected={
                        report_claim_id &&
                        moment(
                          String(report_claim_id).length < 13 ? moment.unix(report_claim_id) : report_claim_id
                        ).toDate()
                      }
                      onChange={date =>
                        this.handleUpdateTextArea(
                          'report_claim_id',
                          date ? moment(date).unix() : moment(Date.now()).unix()
                        )
                      }
                      minDate={new Date('2000-01-01')}
                      disabled={!REPORT_PERMISSIONS.edit}
                      showYearDropdown
                      showMonthDropdown
                    />
                  </Row>
                </Col>
              </Row>
              <Row type="flex" justify="space-between" align="middle" className="row">
                <Col md={24} className="mt-2">
                  <InlineContact
                    getReportContacts={this.getReportContacts}
                    getContactLists={this.getContactLists}
                    contact_type_id={dataDynamic.plaintiff_attorney_id}
                    another={false}
                    label={PLAINTIFF_ATTORNEY_TYPE.name}
                    report_id={report_id}
                    contactsList={plaintifList}
                    type={PLAINTIFF_ATTORNEY_TYPE.field}
                    disabled={!REPORT_PERMISSIONS.edit}
                    value={report_contacts
                      .filter(item => item.type === PLAINTIFF_ATTORNEY_TYPE.field)
                      .map(item => {
                        if (!item.contact) {
                          return null;
                        }
                        return item.contact.id;
                      })
                      .filter(x => x)}
                  />
                </Col>

                <Col sm={24} className="style_textarea">
                  <RichTextEditor
                    onChange={value => this.handleUpdateTextArea('medical_summary', value)}
                    value={medical_summary}
                    label="Medical Summary"
                    disabled={!REPORT_PERMISSIONS.edit}
                  />
                </Col>
                <Col md={24} className="style_textarea">
                  <RichTextEditor
                    label="Current Medical Status"
                    placeholder="Please enter"
                    value={medical_status}
                    disabled={!REPORT_PERMISSIONS.edit}
                    onChange={value => this.handleUpdateTextArea('medical_status', value)}
                  />
                </Col>
                <Col sm={24} className="style_textarea">
                  <RichTextEditor
                    disabled={!REPORT_PERMISSIONS.edit}
                    onChange={value => this.handleUpdateTextArea('projected_treatment_plan', value)}
                    value={projected_treatment_plan}
                    label="Projected Future Medical Care"
                  />
                </Col>
              </Row>

              <Row type="flex" justify="space-between" align="middle" className="row">
                <Col md={11}>
                  <Row className="label">
                    <Text>Referral Date</Text>
                  </Row>
                  <Row>
                    <DatePickerSimple
                      className="demographic-date"
                      placeholderText="Select Referral Date"
                      selected={referral_date?.toDate()}
                      onChange={date => this.setState({ referral_date: date ? moment(date) : undefined })}
                      minDate={new Date('2000-01-01')}
                      showYearDropdown
                      showMonthDropdown
                      disabled={!REPORT_PERMISSIONS.edit}
                    />
                  </Row>
                </Col>
                <Col md={11}>
                  <Row className="label">
                    <Text>Date of Report</Text>
                  </Row>
                  <Row>
                    <DatePickerSimple
                      className="demographic-date"
                      placeholderText="Select Date of Report"
                      selected={date_of_report?.toDate()}
                      onChange={date => this.setState({ date_of_report: date ? moment(date) : undefined })}
                      minDate={new Date('2000-01-01')}
                      showYearDropdown
                      showMonthDropdown
                      disabled={!REPORT_PERMISSIONS.edit}
                    />
                  </Row>
                </Col>
              </Row>

              {(is_template || this.state.report_template_id) && (
                <TemplateFields
                  is_template={is_template}
                  section_id={25}
                  report_template_id={this.state.report_template_id}
                  report_id={this.state.report_id}
                />
              )}

              {REPORT_PERMISSIONS.signature && !this.state.is_template && (
                <SignatureReport
                  defaultSignature={signature}
                  onChangeSignature={this.handleChangeSignature}
                  onDeleteSignature={this.handleDeleteSignature}
                  onAddSignature={this.handleAddSignature}
                  disabled={!REPORT_PERMISSIONS.edit}
                />
              )}
              <Divider className="divider" />
              <PrevNextStep
                saveDraft={REPORT_PERMISSIONS.saveDraft}
                beforeNext={async () => await this.handleUpdateReport(true)}
              />
            </Row>
          </SpinBox>
        </Row>
      </Row>
    );
  }
}

const mapStateToProps = state => {
  const props = {
    autoSavingTime: state.report.autoSavingTime,
    reportInfo: state.report.reportInfo,
    roles: state.auth.roles,
    userInfo: state.auth.userInfo,
  };
  return props;
};

export default connect(mapStateToProps, { updateReportInfo })(MedicalContent);
